module.exports = __webpack_public_path__ + "static/img/function-box-img6.cd30de9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegration/function-box-img6.png
// module id = 12ZK
// module chunks = 0